module.exports = __webpack_public_path__ + "static/media/merriweather-v21-latin-700.ba56ea84.woff";